import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Link from 'next/link';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { getAuthorFullName } from '@/helpers/helpers';

import { ITop100Books } from '@/interfaces/top100Books.interface';
import styles from './TopBooks.module.scss';

interface ITopBooksPage {
  topData: ITop100Books;
}

const TopBooks: FC<ITopBooksPage> = ({ topData }) => {
  //seo block
  const SEO_TITLE = 'Самые часто оцениваемые книги :: Электронная библиотека bookZ.ru';
  const SEO_DESCRIPTION = 'Рейтинг 100 самых оцениваемых книг :: BookZ.ru';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref="/top100_books" breadcrumbs={<Breadcrumbs firstPageName="Топ 100 книг" />}>
      <SectionTitle name="Топ 100 книг" />
      <ul className={styles.topList}>
        {/* заглушка пока нет данных */}

        {topData.data.map((item, i) => (
          <li className={styles.topList__item} key={i}>
            <span className={styles.topList__itemWrap}>
              <span className={styles.topList__links}>
                <Link prefetch={false} href={`/authors/${item.author.alias}/${item.alias}`} className={styles.topList__title}>
                  <b>{++i}</b>. {item.book.title}
                  <span className={styles.topList__type}> ({item.book.type === 'book' ? 'книга' : 'aудиокнига'})</span>
                </Link>
                <Link prefetch={false} href={`/authors/${item.author.alias}`} className={styles.topList__author}>
                  {getAuthorFullName(item.author.first_name, item.author.middle_name || '', item.author.last_name)}
                </Link>
              </span>
              <span className={styles.topList__counter}>{item.views_count}</span>
            </span>
          </li>
        ))}
      </ul>
    </Layout>
  );
};
export default TopBooks;
